/// <amd-module name="Test/ManualTestReports/TestReportsCommon/UrlCreator" />

import { getTFSPageData } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

export function getSuiteUrl(planId: number, suiteId: number, pageContext: IVssPageContext) {
    const testplanRoute = "ms.vss-test-web.test-testplan-route";

    const routeValues: { [key: string]: string } = {};
    routeValues["planId"] = planId.toString();
    routeValues["suiteId"] = suiteId.toString();

    return _fetchUrl(pageContext, routeValues, testplanRoute);
}

export function getNewTestPlanUrl(pageContext: IVssPageContext) {
    const testplanRoute = "ms.vss-test-web.test-plan-directory-route";

    const routeValues: { [key: string]: string } = {};
    routeValues["pivot"] = "new";

    return _fetchUrl(pageContext, routeValues, testplanRoute);
}

export function _fetchUrl(pageContext: IVssPageContext, routeValues: { [key: string]: string }, routeId: string) {
    const tfsProjectData = getTFSPageData(pageContext);

    routeValues["project"] = tfsProjectData && tfsProjectData.project ? tfsProjectData.project.name : "";

    return routeUrl(pageContext, routeId, routeValues);
}